import { useContext } from 'react';
import { AnalyticsContext } from './AnalyticsContext';

const useAnalyticsContext = () => useContext(AnalyticsContext);

export default useAnalyticsContext;
